import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { CarteraPage } from '../pages/cartera/cartera';
import { MovimientoCarteraPage } from '../pages/movimiento-cartera/movimiento-cartera';
import { LoginPage } from '../pages/login/login';

import { SaldosPage } from '../pages/saldos/saldos';
import { ConsolidadoPage } from '../pages/consolidado/consolidado'
import { EnviocorreoPage } from '../pages/enviocorreo/enviocorreo'
import {MedidaPage} from '../pages/medida/medida'
import {DepartamentoPage} from '../pages/departamento/departamento'
import {BusquedaPage} from '../pages/busqueda/busqueda'
import {EntidadPage} from '../pages/entidad/entidad'
import { ComprobantesPage } from '../pages/comprobantes/comprobantes'
import {CuentaTesoreriaPage} from '../pages/cuenta-tesoreria/cuenta-tesoreria'
import {MovimientoTesoreriaPage} from '../pages/movimiento-tesoreria/movimiento-tesoreria'
import { MovimientoTransferenciaTesoreriaPage } from '../pages/movimiento-transferencia-tesoreria/movimiento-transferencia-tesoreria'
import { RepoteEstadocuentaPage } from '../pages/repote-estadocuenta/repote-estadocuenta'
import { DocumentoPage } from '../pages/documento/documento'

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { CarteraServiceProvider } from '../providers/cartera-service/cartera-service';
import { MovimientocarteraServiceProvider } from '../providers/movimientocartera-service/movimientocartera-service';
import { UsuarioServiceProvider } from '../providers/usuario-service/usuario-service';
import { EntidadServiceProvider } from '../providers/entidad-service/entidad-service';
import { AutoCompleteModule } from 'ionic2-auto-complete';
import { AuthServiceProvider } from '../providers/auth-service/auth-service';
import { FileTransfer } from '@ionic-native/file-transfer';
import { EmpleadoServiceProvider } from '../providers/empleado-service/empleado-service';
import { MovimientotesoreriaServiceProvider } from '../providers/movimientotesoreria-service/movimientotesoreria-service';
import { DocumentoServiceProvider } from '../providers/documento-service/documento-service';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {TreeNodeComponent} from '../components/tree-node/tree-node';
import {TreeFolderComponent} from '../components/tree-folder/tree-folder';
import {FileUploadModule} from "ng2-file-upload";


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    CarteraPage,
    MovimientoCarteraPage,
    LoginPage,
    SaldosPage,
    ConsolidadoPage,
    EnviocorreoPage,
    MedidaPage,
    DepartamentoPage,
    BusquedaPage,
    EntidadPage,
    ComprobantesPage,
    CuentaTesoreriaPage,
    MovimientoTesoreriaPage,
    TreeNodeComponent,
    TreeFolderComponent,
    MovimientoTransferenciaTesoreriaPage,
    RepoteEstadocuentaPage,
    DocumentoPage
  ],
  imports: [
    BrowserModule,
    AutoCompleteModule,
    FileUploadModule,
    HttpModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    CarteraPage,
    MovimientoCarteraPage,
    LoginPage,
    SaldosPage,
    ConsolidadoPage,
    EnviocorreoPage,
    MedidaPage,
    DepartamentoPage,
    BusquedaPage,
    EntidadPage,
    ComprobantesPage,
    CuentaTesoreriaPage,
    MovimientoTesoreriaPage,
    MovimientoTransferenciaTesoreriaPage,
    RepoteEstadocuentaPage,
    DocumentoPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    FileTransfer,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    CarteraServiceProvider,
    MovimientocarteraServiceProvider,
    UsuarioServiceProvider,
    EntidadServiceProvider,
    AuthServiceProvider,
    EmpleadoServiceProvider,
    MovimientotesoreriaServiceProvider,
    DocumentoServiceProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts